var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","z-index":"10","top":"10px","left":"10px"}},[_c('el-radio-group',{attrs:{"size":"mini"},model:{value:(_vm.setMapMode),callback:function ($$v) {_vm.setMapMode=$$v},expression:"setMapMode"}},[_c('el-radio-button',{attrs:{"label":"地图"}}),_c('el-radio-button',{attrs:{"label":"混合"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }